// Left offset of the collapsible panel: the difference between its current
// and configured widths. Equal widths (always the case for a theme token such
// as 'layoutLeftWidth') need no arithmetic, and a width parseInt cannot read
// falls back to 0 instead of producing "NaNpx".
export const getLeftOffset = (
  leftWidth: string | number,
  lWidth: string | number,
): string => {
  if (leftWidth === lWidth) return '0px';
  const offset = parseInt(`${leftWidth}`) - parseInt(`${lWidth}`);
  return `${Number.isNaN(offset) ? 0 : offset}px`;
};
